import { useRecoilCallback } from 'recoil';
import { cartState } from '../atoms';
import { useEffect } from 'react';

// Catch "can't find variable: BroadcastChannel" error in SSR
if (typeof BroadcastChannel === 'undefined') {
  global.BroadcastChannel = class {
    constructor() {
      console.warn('BroadcastChannel is not supported in this environment.');
    }
    postMessage() {
      console.warn('BroadcastChannel.postMessage is not supported in this environment.');
    }
  }
}
const channel = new BroadcastChannel('cart-sync');
// Catch crypto.randiomUUID() error in older browsers
if (typeof crypto === 'undefined' || !crypto.randomUUID) {
  global.crypto = {
    randomUUID: () => Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
  }
}
const TAB_ID = crypto.randomUUID();

export const useCartActions = () => {

  const updateCart = useRecoilCallback(({ snapshot, set }) => async (itemId, data, quantity, used = false, broadcast = true) => {
    let updatedCart = { ...await snapshot.getPromise(cartState) };

    if (updatedCart[itemId]) {
      let newItem = { ...updatedCart[itemId] };
      newItem.count = updatedCart[itemId].count + quantity;
      updatedCart[itemId] = newItem;
    } else {
      updatedCart[itemId] = {
        count: quantity,
        isUsed: used,
        data: data
      }
    }
    set(cartState, updatedCart);
    // Broadcast the update only if not triggered by a message
    if (broadcast) {
      channel.postMessage({ type: 'CART_UPDATE', payload: { itemId, data, quantity, used }, origin: TAB_ID });
    }
  });

  const removeItem = useRecoilCallback(({ snapshot, set }) => async (itemId, broadcast = true) => {
    let updatedCart = { ...await snapshot.getPromise(cartState) };
    delete updatedCart[itemId];
    set(cartState, updatedCart);
    if (broadcast) {
      channel.postMessage({ type: 'REMOVE_ITEM', payload: { id: itemId }, origin: TAB_ID });
    }
  });

  useEffect(() => {
    const handleMessage = (event) => {
      const { type, payload, origin } = event.data;
      if (origin === TAB_ID) return; // Ignore self

      if (type === 'CART_UPDATE') updateCart(payload.itemId, payload.data, payload.quantity, payload.used, false);
      if (type === 'REMOVE_ITEM') removeItem(payload.id, false);
    };

    channel.addEventListener('message', handleMessage);
    return () => channel.removeEventListener('message', handleMessage);
  }, [updateCart, removeItem]);

  return { updateCart, removeItem };
};
